export default __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.2a6b668c.ttf";